import { canonicalizeGoal } from "@/features/onboarding/goal-canonical";
import { OnboardingGoals } from "@/features/onboarding/components/onboarding-questions";

export interface RecorderLabel {
  key: string;
  fallback: string;
}

const DEFAULT_RECORDER_LABEL: RecorderLabel = { key: "MENU.SURVEYS", fallback: "Surveys" };

const RECORDER_LABEL_BY_BUCKET: Record<string, RecorderLabel> = {
  [OnboardingGoals.SALES]: { key: "MENU.CALL_RECORDERS", fallback: "Call Recorders" },
  [OnboardingGoals.RESEARCH]: { key: "MENU.SURVEYS_INTERVIEWS", fallback: "Surveys & Interviews" },
  [OnboardingGoals.MEETINGS]: { key: "MENU.RECORDERS", fallback: "Recorders" },
};

/** Recorder nav label for the goal bucket; unknown or missing goals fall back to "Surveys". */
export function getRecorderLabelKey(goal: string | null | undefined): RecorderLabel {
  const bucket = canonicalizeGoal(goal);
  return RECORDER_LABEL_BY_BUCKET[bucket] ?? DEFAULT_RECORDER_LABEL;
}

const DEFAULT_QUICK_ACTION_RECORDER_LABEL: RecorderLabel = {
  key: "QUICK_ACTION.NEW_SURVEY",
  fallback: "Survey",
};

const QUICK_ACTION_RECORDER_LABEL_BY_BUCKET: Record<string, RecorderLabel> = {
  [OnboardingGoals.SALES]: { key: "QUICK_ACTION.NEW_CALL_RECORDER", fallback: "Call Recorder" },
  [OnboardingGoals.MEETINGS]: { key: "QUICK_ACTION.NEW_RECORDER", fallback: "Recorder" },
};

/** Quick-action recorder label per goal bucket; Research keeps the default "Survey". */
export function getQuickActionRecorderLabelKey(goal: string | null | undefined): RecorderLabel {
  const bucket = canonicalizeGoal(goal);
  return QUICK_ACTION_RECORDER_LABEL_BY_BUCKET[bucket] ?? DEFAULT_QUICK_ACTION_RECORDER_LABEL;
}
